<script>
  import { getContext } from "svelte";
  import Icon from "svelte-awesome";
  import { fade } from "svelte/transition";
  import {
    faFillDrip,
    faPaintBrush,
    faUndo,
    faRedo,
    faCircle,
    faTint,
    faCheck,
    faMinus,
    faArrowsAlt
  } from "@fortawesome/free-solid-svg-icons";
  import { faPalette } from "@fortawesome/free-solid-svg-icons/faPalette";
  import iro from "@jaames/iro";
  import { hexToArray } from "./ts/utils";
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { ctrolDisplayFlag } from './store';
  const { getCfd } = getContext("paint");
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

  let colorStack = ["#e53935", "#2196f3", "#4caf50", "#5e35b1", "#000000"];
  let isOpenColorpicker = false;
  // icon scale
  let scale = 1.0;


  let colorPickerElem;
  let colorPickerActive = false;
  let colorSelection = colorStack[0];
  let currentColor = colorStack[0];
  let bucketMode = true;

  const progress = tweened(0, {
    duration: 400,
    easing: cubicOut,
  });

  $: getCfd().setDrawingColor(currentColor);
  $: getCfd().setBucketMode(bucketMode);

  function useColorPicker(colorPickerContainer) {
    colorPickerElem = iro.ColorPicker(colorPickerContainer, {
      color: colorSelection,
      display: "none",
      width: 260,
    });
    colorPickerElem.on("color:change", function (color) {
      colorSelection = color.hexString;
    });
  }

  function handleColorPicker() {
    colorPickerActive = !colorPickerActive;
    // hide / unhide
    colorPickerElem.setOptions({
      display: colorPickerActive ? "block" : "none",
    });

    if (colorPickerActive || currentColor === colorSelection) {
      return;
    }
    currentColor = colorSelection;
    colorStack.shift();
    colorStack.push(currentColor);
    colorStack = [...colorStack];
  }

  function minimize(event) {
		dispatch('message',{});
  }
  
</script>

<style lang="scss">
  @import "scss/controls";
  @import "scss/animation"; 

  :global() {
    :focus {
      outline: none;
    }
  }

  .inactive[style] {
    border: 4px solid #888 !important;
    background-color: #cacaca !important;
  }

  .attribution{
    width:100%;
    text-align:center
  }

  .icon-btn{
    font-size:2rem;
    color : #f9f9f9;
  }
  
</style>

<div class="controls  drag-handle" tootlip="Click and hold to drag me">
   <div class="header">
       <div class="title">
        <a href="https://www.pixobe.com" target="_blank"> www.pixobe.com</a>
       </div>
       <div on:click={minimize}  on:touchstart={minimize} class="close-btn">
          &times;
       </div>
   </div>
  <div class="grid-row">
    <div class="grid-col">
      <div class="grid-row">
        {#each colorStack as color, i (color + i)}
          <div class="grid-col" on:click={() => (currentColor = color)}>
            <button class="circle" style="background-color:{color}"  />
          </div>
        {/each}
      </div>
      <div class="grid-row">
        <div class="grid-col">
          <button
            class="circle"
            style="background-color:{currentColor}"
            class:inactive={!bucketMode}
            on:click={() => (bucketMode = !bucketMode)}>
            <Icon data={faFillDrip} {scale} />
          </button>
        </div>
        <div class="grid-col">
          <button
            class="circle"
            style="background-color:{currentColor}"
            class:inactive={bucketMode}
            on:click={() => (bucketMode = !bucketMode)}>
            <Icon data={faPaintBrush} {scale} />
          </button>
        </div>
        <div class="grid-col">
          <button
            class="circle"
            class:animate-bg={colorPickerActive}
            class:pallette={!colorPickerActive}
            on:click={handleColorPicker}>
            <Icon data={colorPickerActive ? faCheck : faPalette} {scale} />
          </button>
        </div>
        <div class="grid-col">
          <button class="circle" on:click={() => getCfd().undo()}>
            <Icon data={faUndo} {scale} />
          </button>
        </div>
        <div class="grid-col">
          <button class="circle" on:click={() => getCfd().redo()}>
            <Icon data={faRedo} {scale} />
          </button>
        </div>
      </div>
      <div class="grid-row picker">
        <div class="grid-col " use:useColorPicker transition:fade />
      </div>
      <div class="attribution">For any plugin development please contact <a href="mailto:email@pixobe.com" target="_blank">email@pixobe.com</a></div>
    </div>
  </div>
</div>
